/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Startzeit1Inputs */

const de__field_startzeit1 = /** @type {(inputs: _Field_Startzeit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startzeit`)
};

/**

* @param {_Field_Startzeit1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_startzeit1 = /** @type {((inputs?: _Field_Startzeit1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Startzeit1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_startzeit1(inputs)
});
export { _field_startzeit1 as "_field_startZeit" }